module.exports = "/_next/static/images/trending-sedans-small-80e4c8547a4aa979634484d8efb8bbfe.jpg";